import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';

/**
 * Custom HttpParameterCodec
 * Workaround for https://github.com/angular/angular/issues/18261
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class CustomHttpParameterCodec {
    encodeKey(k) {
        return encodeURIComponent(k);
    }
    encodeValue(v) {
        return encodeURIComponent(v);
    }
    decodeKey(k) {
        return decodeURIComponent(k);
    }
    decodeValue(v) {
        return decodeURIComponent(v);
    }
}

const BASE_PATH = new InjectionToken('basePath');
const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
};

class Configuration {
    constructor(configurationParameters = {}) {
        this.apiKeys = configurationParameters.apiKeys;
        this.username = configurationParameters.username;
        this.password = configurationParameters.password;
        this.accessToken = configurationParameters.accessToken;
        this.basePath = configurationParameters.basePath;
        this.withCredentials = configurationParameters.withCredentials;
        this.encoder = configurationParameters.encoder;
        if (configurationParameters.credentials) {
            this.credentials = configurationParameters.credentials;
        }
        else {
            this.credentials = {};
        }
    }
    /**
     * Select the correct content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param contentTypes - the array of content types that are available for selection
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderContentType(contentTypes) {
        if (contentTypes.length === 0) {
            return undefined;
        }
        const type = contentTypes.find((x) => this.isJsonMime(x));
        if (type === undefined) {
            return contentTypes[0];
        }
        return type;
    }
    /**
     * Select the correct accept content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param accepts - the array of content types that are available for selection.
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderAccept(accepts) {
        if (accepts.length === 0) {
            return undefined;
        }
        const type = accepts.find((x) => this.isJsonMime(x));
        if (type === undefined) {
            return accepts[0];
        }
        return type;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
    lookupCredential(key) {
        const value = this.credentials[key];
        return typeof value === 'function'
            ? value()
            : value;
    }
}

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class GoogleAuthenticationDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getGoogleAccessToken(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/google/v1/access-token`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
GoogleAuthenticationDataService.ɵfac = function GoogleAuthenticationDataService_Factory(t) { return new (t || GoogleAuthenticationDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
GoogleAuthenticationDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function GoogleAuthenticationDataService_Factory() { return new GoogleAuthenticationDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: GoogleAuthenticationDataService, providedIn: "root" });
GoogleAuthenticationDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleAuthenticationDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearConfigDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getClientConfiguration(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/client-config/simple`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearConfigDataService.ɵfac = function LinearConfigDataService_Factory(t) { return new (t || LinearConfigDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearConfigDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearConfigDataService_Factory() { return new LinearConfigDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearConfigDataService, providedIn: "root" });
LinearConfigDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearConfigDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearFeedDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getFeed(feedId, layout, limit, offset, observe = 'body', reportProgress = false, options) {
        if (feedId === null || feedId === undefined) {
            throw new Error('Required parameter feedId was null or undefined when calling getFeed.');
        }
        if (layout === null || layout === undefined) {
            throw new Error('Required parameter layout was null or undefined when calling getFeed.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (limit !== undefined && limit !== null) {
            queryParameters = this.addToHttpParams(queryParameters, limit, 'limit');
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = this.addToHttpParams(queryParameters, offset, 'offset');
        }
        if (layout !== undefined && layout !== null) {
            queryParameters = this.addToHttpParams(queryParameters, layout, 'layout');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/feed/${encodeURIComponent(String(feedId))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearFeedDataService.ɵfac = function LinearFeedDataService_Factory(t) { return new (t || LinearFeedDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearFeedDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearFeedDataService_Factory() { return new LinearFeedDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearFeedDataService, providedIn: "root" });
LinearFeedDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearFeedDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearMenuDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getMenu(profileType, tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (profileType !== undefined && profileType !== null) {
            queryParameters = this.addToHttpParams(queryParameters, profileType, 'profileType');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/menu`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getMenuV2(profileType, tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (profileType !== undefined && profileType !== null) {
            queryParameters = this.addToHttpParams(queryParameters, profileType, 'profileType');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v2/menu`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getMenuV3(profileType, tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (profileType !== undefined && profileType !== null) {
            queryParameters = this.addToHttpParams(queryParameters, profileType, 'profileType');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v3/menu`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearMenuDataService.ɵfac = function LinearMenuDataService_Factory(t) { return new (t || LinearMenuDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearMenuDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearMenuDataService_Factory() { return new LinearMenuDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearMenuDataService, providedIn: "root" });
LinearMenuDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearMenuDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearPageDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getPageItemByType(pageItemType, slug, limit, offset, observe = 'body', reportProgress = false, options) {
        if (pageItemType === null || pageItemType === undefined) {
            throw new Error('Required parameter pageItemType was null or undefined when calling getPageItemByType.');
        }
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling getPageItemByType.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (limit !== undefined && limit !== null) {
            queryParameters = this.addToHttpParams(queryParameters, limit, 'limit');
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = this.addToHttpParams(queryParameters, offset, 'offset');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/page-item/${encodeURIComponent(String(pageItemType))}/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    page(slug, platform, userSegment, dthStatus, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling page.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (dthStatus !== undefined && dthStatus !== null) {
            queryParameters = this.addToHttpParams(queryParameters, dthStatus, 'dthStatus');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV2(slug, userSegment, dthStatus, countryCode, platform, tenantId, pastLinearProgramAvailabilityDays, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (dthStatus !== undefined && dthStatus !== null) {
            queryParameters = this.addToHttpParams(queryParameters, dthStatus, 'dthStatus');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (pastLinearProgramAvailabilityDays !== undefined && pastLinearProgramAvailabilityDays !== null) {
            queryParameters = this.addToHttpParams(queryParameters, pastLinearProgramAvailabilityDays, 'pastLinearProgramAvailabilityDays');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v2/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV3(slug, userSegment, dthStatus, countryCode, platform, tenantId, pastLinearProgramAvailabilityDays, ondemandTenantId, ondemandContentLimit, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV3.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (dthStatus !== undefined && dthStatus !== null) {
            queryParameters = this.addToHttpParams(queryParameters, dthStatus, 'dthStatus');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (pastLinearProgramAvailabilityDays !== undefined && pastLinearProgramAvailabilityDays !== null) {
            queryParameters = this.addToHttpParams(queryParameters, pastLinearProgramAvailabilityDays, 'pastLinearProgramAvailabilityDays');
        }
        if (ondemandTenantId !== undefined && ondemandTenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, ondemandTenantId, 'ondemandTenantId');
        }
        if (ondemandContentLimit !== undefined && ondemandContentLimit !== null) {
            queryParameters = this.addToHttpParams(queryParameters, ondemandContentLimit, 'ondemandContentLimit');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v3/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV4(slug, userSegment, dthStatus, countryCode, platform, tenantId, pastLinearProgramAvailabilityDays, ondemandTenantId, contentGroupLimit, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV4.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (dthStatus !== undefined && dthStatus !== null) {
            queryParameters = this.addToHttpParams(queryParameters, dthStatus, 'dthStatus');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (pastLinearProgramAvailabilityDays !== undefined && pastLinearProgramAvailabilityDays !== null) {
            queryParameters = this.addToHttpParams(queryParameters, pastLinearProgramAvailabilityDays, 'pastLinearProgramAvailabilityDays');
        }
        if (ondemandTenantId !== undefined && ondemandTenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, ondemandTenantId, 'ondemandTenantId');
        }
        if (contentGroupLimit !== undefined && contentGroupLimit !== null) {
            queryParameters = this.addToHttpParams(queryParameters, contentGroupLimit, 'contentGroupLimit');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v4/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearPageDataService.ɵfac = function LinearPageDataService_Factory(t) { return new (t || LinearPageDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearPageDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearPageDataService_Factory() { return new LinearPageDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearPageDataService, providedIn: "root" });
LinearPageDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearPageDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearRecommendationSearchDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getSearchRecommendations(sessionId, countryCode, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/recommendation/search-recommendations`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearRecommendationSearchDataService.ɵfac = function LinearRecommendationSearchDataService_Factory(t) { return new (t || LinearRecommendationSearchDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearRecommendationSearchDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearRecommendationSearchDataService_Factory() { return new LinearRecommendationSearchDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearRecommendationSearchDataService, providedIn: "root" });
LinearRecommendationSearchDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearRecommendationSearchDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearSearchDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getSearchAutocomplete(searchTerm, sessionId, observe = 'body', reportProgress = false, options) {
        if (searchTerm === null || searchTerm === undefined) {
            throw new Error('Required parameter searchTerm was null or undefined when calling getSearchAutocomplete.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (searchTerm !== undefined && searchTerm !== null) {
            queryParameters = this.addToHttpParams(queryParameters, searchTerm, 'searchTerm');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/recommendation/search-term-autocomplete`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    search(searchTerm, sessionId, programTypes, observe = 'body', reportProgress = false, options) {
        if (searchTerm === null || searchTerm === undefined) {
            throw new Error('Required parameter searchTerm was null or undefined when calling search.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (searchTerm !== undefined && searchTerm !== null) {
            queryParameters = this.addToHttpParams(queryParameters, searchTerm, 'searchTerm');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (programTypes) {
            queryParameters = this.addToHttpParams(queryParameters, programTypes.join(COLLECTION_FORMATS['csv']), 'programTypes');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/recommendation/search`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearSearchDataService.ɵfac = function LinearSearchDataService_Factory(t) { return new (t || LinearSearchDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearSearchDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearSearchDataService_Factory() { return new LinearSearchDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearSearchDataService, providedIn: "root" });
LinearSearchDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearSearchDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class LinearTenantConfigDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getTenantConfig(tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/tenant-config`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
LinearTenantConfigDataService.ɵfac = function LinearTenantConfigDataService_Factory(t) { return new (t || LinearTenantConfigDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LinearTenantConfigDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinearTenantConfigDataService_Factory() { return new LinearTenantConfigDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: LinearTenantConfigDataService, providedIn: "root" });
LinearTenantConfigDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearTenantConfigDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class OndemandRecommendationDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getOndemandRecommendedContents(limit, programAvailabilityGuid, countryCode, accountNumber, serialNumber, rating, availabilityTag, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (limit !== undefined && limit !== null) {
            queryParameters = this.addToHttpParams(queryParameters, limit, 'limit');
        }
        if (programAvailabilityGuid !== undefined && programAvailabilityGuid !== null) {
            queryParameters = this.addToHttpParams(queryParameters, programAvailabilityGuid, 'programAvailabilityGuid');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (accountNumber !== undefined && accountNumber !== null) {
            queryParameters = this.addToHttpParams(queryParameters, accountNumber, 'accountNumber');
        }
        if (serialNumber !== undefined && serialNumber !== null) {
            queryParameters = this.addToHttpParams(queryParameters, serialNumber, 'serialNumber');
        }
        if (rating !== undefined && rating !== null) {
            queryParameters = this.addToHttpParams(queryParameters, rating, 'rating');
        }
        if (availabilityTag !== undefined && availabilityTag !== null) {
            queryParameters = this.addToHttpParams(queryParameters, availabilityTag, 'availabilityTag');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/recommendation/ondemand`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
OndemandRecommendationDataService.ɵfac = function OndemandRecommendationDataService_Factory(t) { return new (t || OndemandRecommendationDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
OndemandRecommendationDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function OndemandRecommendationDataService_Factory() { return new OndemandRecommendationDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: OndemandRecommendationDataService, providedIn: "root" });
OndemandRecommendationDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OndemandRecommendationDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StbRecommendationLearnDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    learnActionVodSearchSelected(sessionId, learnActionVodSelectedApiModel, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post(`${this.configuration.basePath}/stb/v1/recommendation/learn/vod-search-result-selected`, learnActionVodSelectedApiModel, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StbRecommendationLearnDataService.ɵfac = function StbRecommendationLearnDataService_Factory(t) { return new (t || StbRecommendationLearnDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StbRecommendationLearnDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StbRecommendationLearnDataService_Factory() { return new StbRecommendationLearnDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StbRecommendationLearnDataService, providedIn: "root" });
StbRecommendationLearnDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StbRecommendationLearnDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StbRecommendationSimilarTitlesDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getSimilarProgramAvailabilitiesV2(programAvailabilityGuid, sessionId, observe = 'body', reportProgress = false, options) {
        if (programAvailabilityGuid === null || programAvailabilityGuid === undefined) {
            throw new Error('Required parameter programAvailabilityGuid was null or undefined when calling getSimilarProgramAvailabilitiesV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (programAvailabilityGuid !== undefined && programAvailabilityGuid !== null) {
            queryParameters = this.addToHttpParams(queryParameters, programAvailabilityGuid, 'programAvailabilityGuid');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/recommendation/similar-titles`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StbRecommendationSimilarTitlesDataService.ɵfac = function StbRecommendationSimilarTitlesDataService_Factory(t) { return new (t || StbRecommendationSimilarTitlesDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StbRecommendationSimilarTitlesDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StbRecommendationSimilarTitlesDataService_Factory() { return new StbRecommendationSimilarTitlesDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StbRecommendationSimilarTitlesDataService, providedIn: "root" });
StbRecommendationSimilarTitlesDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StbRecommendationSimilarTitlesDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StbRecommendationTrayDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getRecommendationTrayContent(sessionId, countryCode, additionalProperties, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (additionalProperties !== undefined && additionalProperties !== null) {
            queryParameters = this.addToHttpParams(queryParameters, additionalProperties, 'additionalProperties');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/stb/v1/recommendation/tray`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StbRecommendationTrayDataService.ɵfac = function StbRecommendationTrayDataService_Factory(t) { return new (t || StbRecommendationTrayDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StbRecommendationTrayDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StbRecommendationTrayDataService_Factory() { return new StbRecommendationTrayDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StbRecommendationTrayDataService, providedIn: "root" });
StbRecommendationTrayDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StbRecommendationTrayDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingAppleDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    partnerManifest(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/apple/partner-manifest`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    umcAvailability(countryCode, observe = 'body', reportProgress = false, options) {
        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling umcAvailability.');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/apple/availability/${encodeURIComponent(String(countryCode))}`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    umcCatalog(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/apple/catalog`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingAppleDataService.ɵfac = function StreamingAppleDataService_Factory(t) { return new (t || StreamingAppleDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingAppleDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingAppleDataService_Factory() { return new StreamingAppleDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingAppleDataService, providedIn: "root" });
StreamingAppleDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingAppleDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingClientConfigDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getStreamingClientConfiguration(platform, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/client-config`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getStreamingSimpleClientConfiguration(platform, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/client-config/simple`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getStreamingSimpleClientConfigurationV2(platform, observe = 'body', reportProgress = false, options) {
        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling getStreamingSimpleClientConfigurationV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/client-config/simple`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingClientConfigDataService.ɵfac = function StreamingClientConfigDataService_Factory(t) { return new (t || StreamingClientConfigDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingClientConfigDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingClientConfigDataService_Factory() { return new StreamingClientConfigDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingClientConfigDataService, providedIn: "root" });
StreamingClientConfigDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingClientConfigDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingCollectionPageDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    collectionPageV1(slug, platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling collectionPageV1.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/collection-page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingCollectionPageDataService.ɵfac = function StreamingCollectionPageDataService_Factory(t) { return new (t || StreamingCollectionPageDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingCollectionPageDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingCollectionPageDataService_Factory() { return new StreamingCollectionPageDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingCollectionPageDataService, providedIn: "root" });
StreamingCollectionPageDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingCollectionPageDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingDetailPageDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    marketingMovieDetailPageV2(contentGuid, platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (contentGuid === null || contentGuid === undefined) {
            throw new Error('Required parameter contentGuid was null or undefined when calling marketingMovieDetailPageV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/marketing-movie-detail-page/${encodeURIComponent(String(contentGuid))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    marketingSeriesDetailPageV2(contentGuid, platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (contentGuid === null || contentGuid === undefined) {
            throw new Error('Required parameter contentGuid was null or undefined when calling marketingSeriesDetailPageV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/marketing-series-detail-page/${encodeURIComponent(String(contentGuid))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingDetailPageDataService.ɵfac = function StreamingDetailPageDataService_Factory(t) { return new (t || StreamingDetailPageDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingDetailPageDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingDetailPageDataService_Factory() { return new StreamingDetailPageDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingDetailPageDataService, providedIn: "root" });
StreamingDetailPageDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingDetailPageDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingGatewayRedeemAssetsDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getAllRedeemSignupAssets(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/gateway/signup-assets/all`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getRedeemSignupAsset(campaign, countryCode, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (campaign !== undefined && campaign !== null) {
            queryParameters = this.addToHttpParams(queryParameters, campaign, 'campaign');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/gateway/signup-assets`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingGatewayRedeemAssetsDataService.ɵfac = function StreamingGatewayRedeemAssetsDataService_Factory(t) { return new (t || StreamingGatewayRedeemAssetsDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingGatewayRedeemAssetsDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingGatewayRedeemAssetsDataService_Factory() { return new StreamingGatewayRedeemAssetsDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingGatewayRedeemAssetsDataService, providedIn: "root" });
StreamingGatewayRedeemAssetsDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingGatewayRedeemAssetsDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingGenrePageDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    genrePage(genre, platform, userSegment, countryCode, tenantId, shuffleHero, observe = 'body', reportProgress = false, options) {
        if (genre === null || genre === undefined) {
            throw new Error('Required parameter genre was null or undefined when calling genrePage.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (shuffleHero !== undefined && shuffleHero !== null) {
            queryParameters = this.addToHttpParams(queryParameters, shuffleHero, 'shuffleHero');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/genre-page/${encodeURIComponent(String(genre))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingGenrePageDataService.ɵfac = function StreamingGenrePageDataService_Factory(t) { return new (t || StreamingGenrePageDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingGenrePageDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingGenrePageDataService_Factory() { return new StreamingGenrePageDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingGenrePageDataService, providedIn: "root" });
StreamingGenrePageDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingGenrePageDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingMenuDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getStreamingMenu(platform, profileType, tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (profileType !== undefined && profileType !== null) {
            queryParameters = this.addToHttpParams(queryParameters, profileType, 'profileType');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/menu`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getStreamingMenuV2(platform, profileType, tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (profileType !== undefined && profileType !== null) {
            queryParameters = this.addToHttpParams(queryParameters, profileType, 'profileType');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/menu`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingMenuDataService.ɵfac = function StreamingMenuDataService_Factory(t) { return new (t || StreamingMenuDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingMenuDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingMenuDataService_Factory() { return new StreamingMenuDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingMenuDataService, providedIn: "root" });
StreamingMenuDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingMenuDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingPageDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    marketingMovieDetailPageV1(contentGuid, platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (contentGuid === null || contentGuid === undefined) {
            throw new Error('Required parameter contentGuid was null or undefined when calling marketingMovieDetailPageV1.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/marketing-movie-detail-page/${encodeURIComponent(String(contentGuid))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    marketingSeriesDetailPageV1(contentGuid, platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (contentGuid === null || contentGuid === undefined) {
            throw new Error('Required parameter contentGuid was null or undefined when calling marketingSeriesDetailPageV1.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/marketing-series-detail-page/${encodeURIComponent(String(contentGuid))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageItemV1(slug, platform, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageItemV1.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/page-item/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageItemV2(slug, platform, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageItemV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/page-item/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageItemV3(slug, platform, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageItemV3.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v3/page-item/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageItemV4(slug, platform, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageItemV4.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v4/page-item/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV1(slug, platform, userSegment, tenantId, shuffleHero, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV1.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (shuffleHero !== undefined && shuffleHero !== null) {
            queryParameters = this.addToHttpParams(queryParameters, shuffleHero, 'shuffleHero');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV2(slug, platform, userSegment, countryCode, tenantId, shuffleHero, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (shuffleHero !== undefined && shuffleHero !== null) {
            queryParameters = this.addToHttpParams(queryParameters, shuffleHero, 'shuffleHero');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV3(slug, platform, userSegment, countryCode, tenantId, shuffleHero, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV3.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (shuffleHero !== undefined && shuffleHero !== null) {
            queryParameters = this.addToHttpParams(queryParameters, shuffleHero, 'shuffleHero');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v3/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV4(slug, platform, userSegment, countryCode, tenantId, shuffleHero, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV4.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (shuffleHero !== undefined && shuffleHero !== null) {
            queryParameters = this.addToHttpParams(queryParameters, shuffleHero, 'shuffleHero');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v4/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    pageV5(slug, platform, userSegment, countryCode, tenantId, shuffleHero, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling pageV5.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        if (shuffleHero !== undefined && shuffleHero !== null) {
            queryParameters = this.addToHttpParams(queryParameters, shuffleHero, 'shuffleHero');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v5/page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingPageDataService.ɵfac = function StreamingPageDataService_Factory(t) { return new (t || StreamingPageDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingPageDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingPageDataService_Factory() { return new StreamingPageDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingPageDataService, providedIn: "root" });
StreamingPageDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingPageDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingPaywallDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getMobileLandingPage(userSegment, platform, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (userSegment === null || userSegment === undefined) {
            throw new Error('Required parameter userSegment was null or undefined when calling getMobileLandingPage.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/app-landing`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingPaywallDataService.ɵfac = function StreamingPaywallDataService_Factory(t) { return new (t || StreamingPaywallDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingPaywallDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingPaywallDataService_Factory() { return new StreamingPaywallDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingPaywallDataService, providedIn: "root" });
StreamingPaywallDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingPaywallDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingRecommendationLearnDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    learnActionVodBookmarked(sessionId, learnActionVodSelectedApiModel, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post(`${this.configuration.basePath}/frontend/v1/recommendation/learn/vod-bookmark`, learnActionVodSelectedApiModel, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    learnActionVodPlayed(sessionId, learnActionVodApiModel, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post(`${this.configuration.basePath}/frontend/v1/recommendation/learn/vod-played`, learnActionVodApiModel, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    learnActionVodStopped(sessionId, learnActionVodApiModel, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post(`${this.configuration.basePath}/frontend/v1/recommendation/learn/vod-stopped`, learnActionVodApiModel, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    streamingLearnActionVodSearchSelected(sessionId, learnActionVodSelectedApiModel, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.post(`${this.configuration.basePath}/frontend/v1/recommendation/learn/vod-search-result-selected`, learnActionVodSelectedApiModel, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingRecommendationLearnDataService.ɵfac = function StreamingRecommendationLearnDataService_Factory(t) { return new (t || StreamingRecommendationLearnDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingRecommendationLearnDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingRecommendationLearnDataService_Factory() { return new StreamingRecommendationLearnDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingRecommendationLearnDataService, providedIn: "root" });
StreamingRecommendationLearnDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingRecommendationLearnDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingRecommendationRecommendedForYouDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getRecommendedProgramAvailabilities(sessionId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/recommended-for-you`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingRecommendationRecommendedForYouDataService.ɵfac = function StreamingRecommendationRecommendedForYouDataService_Factory(t) { return new (t || StreamingRecommendationRecommendedForYouDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingRecommendationRecommendedForYouDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingRecommendationRecommendedForYouDataService_Factory() { return new StreamingRecommendationRecommendedForYouDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingRecommendationRecommendedForYouDataService, providedIn: "root" });
StreamingRecommendationRecommendedForYouDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingRecommendationRecommendedForYouDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingRecommendationSearchDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getStreamingSearchRecommendations(sessionId, countryCode, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/search-recommendations`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingRecommendationSearchDataService.ɵfac = function StreamingRecommendationSearchDataService_Factory(t) { return new (t || StreamingRecommendationSearchDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingRecommendationSearchDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingRecommendationSearchDataService_Factory() { return new StreamingRecommendationSearchDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingRecommendationSearchDataService, providedIn: "root" });
StreamingRecommendationSearchDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingRecommendationSearchDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingRecommendationTrayDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getStreamingRecommendationTrayContent(sessionId, countryCode, additionalProperties, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (additionalProperties !== undefined && additionalProperties !== null) {
            queryParameters = this.addToHttpParams(queryParameters, additionalProperties, 'additionalProperties');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/tray`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingRecommendationTrayDataService.ɵfac = function StreamingRecommendationTrayDataService_Factory(t) { return new (t || StreamingRecommendationTrayDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingRecommendationTrayDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingRecommendationTrayDataService_Factory() { return new StreamingRecommendationTrayDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingRecommendationTrayDataService, providedIn: "root" });
StreamingRecommendationTrayDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingRecommendationTrayDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingRecommendationTrendingDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getTrendingProgramAvailabilities(sessionId, countryCode, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/trending`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingRecommendationTrendingDataService.ɵfac = function StreamingRecommendationTrendingDataService_Factory(t) { return new (t || StreamingRecommendationTrendingDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingRecommendationTrendingDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingRecommendationTrendingDataService_Factory() { return new StreamingRecommendationTrendingDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingRecommendationTrendingDataService, providedIn: "root" });
StreamingRecommendationTrendingDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingRecommendationTrendingDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingRedeemPageDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    marketingGenericRedeemPageV1(platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/marketing-redeem-page`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    marketingPartnerRedeemPageV1(slug, platform, userSegment, countryCode, tenantId, observe = 'body', reportProgress = false, options) {
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling marketingPartnerRedeemPageV1.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (platform !== undefined && platform !== null) {
            queryParameters = this.addToHttpParams(queryParameters, platform, 'platform');
        }
        if (userSegment !== undefined && userSegment !== null) {
            queryParameters = this.addToHttpParams(queryParameters, userSegment, 'userSegment');
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = this.addToHttpParams(queryParameters, countryCode, 'countryCode');
        }
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, tenantId, 'tenantId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/marketing-redeem-page/${encodeURIComponent(String(slug))}`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingRedeemPageDataService.ɵfac = function StreamingRedeemPageDataService_Factory(t) { return new (t || StreamingRedeemPageDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingRedeemPageDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingRedeemPageDataService_Factory() { return new StreamingRedeemPageDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingRedeemPageDataService, providedIn: "root" });
StreamingRedeemPageDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingRedeemPageDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingSamsungSmartHubDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getPublicPreview(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/samsung-smart-hub/preview/public`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingSamsungSmartHubDataService.ɵfac = function StreamingSamsungSmartHubDataService_Factory(t) { return new (t || StreamingSamsungSmartHubDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingSamsungSmartHubDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingSamsungSmartHubDataService_Factory() { return new StreamingSamsungSmartHubDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingSamsungSmartHubDataService, providedIn: "root" });
StreamingSamsungSmartHubDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingSamsungSmartHubDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingSearchDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getStreamingSearchAutocomplete(searchTerm, sessionId, observe = 'body', reportProgress = false, options) {
        if (searchTerm === null || searchTerm === undefined) {
            throw new Error('Required parameter searchTerm was null or undefined when calling getStreamingSearchAutocomplete.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (searchTerm !== undefined && searchTerm !== null) {
            queryParameters = this.addToHttpParams(queryParameters, searchTerm, 'searchTerm');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/search-term-autocomplete`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    searchV2(searchTerm, sessionId, programType, downloadable, observe = 'body', reportProgress = false, options) {
        if (searchTerm === null || searchTerm === undefined) {
            throw new Error('Required parameter searchTerm was null or undefined when calling searchV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (searchTerm !== undefined && searchTerm !== null) {
            queryParameters = this.addToHttpParams(queryParameters, searchTerm, 'searchTerm');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (programType !== undefined && programType !== null) {
            queryParameters = this.addToHttpParams(queryParameters, programType, 'programType');
        }
        if (downloadable !== undefined && downloadable !== null) {
            queryParameters = this.addToHttpParams(queryParameters, downloadable, 'downloadable');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/recommendation/search`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    streamingSearch(searchTerm, sessionId, programTypes, observe = 'body', reportProgress = false, options) {
        if (searchTerm === null || searchTerm === undefined) {
            throw new Error('Required parameter searchTerm was null or undefined when calling streamingSearch.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (searchTerm !== undefined && searchTerm !== null) {
            queryParameters = this.addToHttpParams(queryParameters, searchTerm, 'searchTerm');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        if (programTypes) {
            queryParameters = this.addToHttpParams(queryParameters, programTypes.join(COLLECTION_FORMATS['csv']), 'programTypes');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/search`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingSearchDataService.ɵfac = function StreamingSearchDataService_Factory(t) { return new (t || StreamingSearchDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingSearchDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingSearchDataService_Factory() { return new StreamingSearchDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingSearchDataService, providedIn: "root" });
StreamingSearchDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingSearchDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingSimilarTitlesDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    getStreamingSimilarProgramAvailabilities(programAvailabilityGuid, sessionId, observe = 'body', reportProgress = false, options) {
        if (programAvailabilityGuid === null || programAvailabilityGuid === undefined) {
            throw new Error('Required parameter programAvailabilityGuid was null or undefined when calling getStreamingSimilarProgramAvailabilities.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (programAvailabilityGuid !== undefined && programAvailabilityGuid !== null) {
            queryParameters = this.addToHttpParams(queryParameters, programAvailabilityGuid, 'programAvailabilityGuid');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v1/recommendation/similar-titles`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    getStreamingSimilarProgramAvailabilitiesV2(programAvailabilityGuid, sessionId, observe = 'body', reportProgress = false, options) {
        if (programAvailabilityGuid === null || programAvailabilityGuid === undefined) {
            throw new Error('Required parameter programAvailabilityGuid was null or undefined when calling getStreamingSimilarProgramAvailabilitiesV2.');
        }
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (programAvailabilityGuid !== undefined && programAvailabilityGuid !== null) {
            queryParameters = this.addToHttpParams(queryParameters, programAvailabilityGuid, 'programAvailabilityGuid');
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = this.addToHttpParams(queryParameters, sessionId, 'sessionId');
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/v2/recommendation/similar-titles`, {
            params: queryParameters,
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingSimilarTitlesDataService.ɵfac = function StreamingSimilarTitlesDataService_Factory(t) { return new (t || StreamingSimilarTitlesDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingSimilarTitlesDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingSimilarTitlesDataService_Factory() { return new StreamingSimilarTitlesDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingSimilarTitlesDataService, providedIn: "root" });
StreamingSimilarTitlesDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingSimilarTitlesDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class StreamingVersionDataService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error("key may not be null if value is Date");
                }
            }
            else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    version(observe = 'body', reportProgress = false, options) {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        let responseType = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.httpClient.get(`${this.configuration.basePath}/frontend/version`, {
            responseType: responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
StreamingVersionDataService.ɵfac = function StreamingVersionDataService_Factory(t) { return new (t || StreamingVersionDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
StreamingVersionDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamingVersionDataService_Factory() { return new StreamingVersionDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(Configuration, 8)); }, token: StreamingVersionDataService, providedIn: "root" });
StreamingVersionDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamingVersionDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

const APIS = [GoogleAuthenticationDataService, LinearConfigDataService, LinearFeedDataService, LinearMenuDataService, LinearPageDataService, LinearRecommendationSearchDataService, LinearSearchDataService, LinearTenantConfigDataService, OndemandRecommendationDataService, StbRecommendationLearnDataService, StbRecommendationSimilarTitlesDataService, StbRecommendationTrayDataService, StreamingAppleDataService, StreamingClientConfigDataService, StreamingCollectionPageDataService, StreamingDetailPageDataService, StreamingGatewayRedeemAssetsDataService, StreamingGenrePageDataService, StreamingMenuDataService, StreamingPageDataService, StreamingPaywallDataService, StreamingRecommendationLearnDataService, StreamingRecommendationRecommendedForYouDataService, StreamingRecommendationSearchDataService, StreamingRecommendationTrayDataService, StreamingRecommendationTrendingDataService, StreamingRedeemPageDataService, StreamingSamsungSmartHubDataService, StreamingSearchDataService, StreamingSimilarTitlesDataService, StreamingVersionDataService];

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var AvailabilityTagApiModel;
(function (AvailabilityTagApiModel) {
    AvailabilityTagApiModel["Ondemand"] = "ONDEMAND";
    AvailabilityTagApiModel["Store"] = "STORE";
})(AvailabilityTagApiModel || (AvailabilityTagApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look&feel of the carousel.
 */
var BannersWithCtaTraylLayoutApiModel;
(function (BannersWithCtaTraylLayoutApiModel) {
    BannersWithCtaTraylLayoutApiModel["TwoThumbnails"] = "TWO_THUMBNAILS";
    BannersWithCtaTraylLayoutApiModel["ThreeThumbnails"] = "THREE_THUMBNAILS";
})(BannersWithCtaTraylLayoutApiModel || (BannersWithCtaTraylLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of the built-in page item
 */
var BuiltInCxbType;
(function (BuiltInCxbType) {
    BuiltInCxbType["LiveChannelCarousel"] = "LiveChannelCarousel";
    BuiltInCxbType["WatchlistCarousel"] = "WatchlistCarousel";
    BuiltInCxbType["ContinueWatchingCarousel"] = "ContinueWatchingCarousel";
})(BuiltInCxbType || (BuiltInCxbType = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of the built-in page item
 */
var BuiltInType;
(function (BuiltInType) {
    BuiltInType["FavouriteChannels"] = "FAVOURITE_CHANNELS";
    BuiltInType["YourReminders"] = "YOUR_REMINDERS";
    BuiltInType["ContinueWatching"] = "CONTINUE_WATCHING";
    BuiltInType["Watchlist"] = "WATCHLIST";
    BuiltInType["TvGuide"] = "TV_GUIDE";
    BuiltInType["LiveChannel"] = "LIVE_CHANNEL";
    BuiltInType["OndemandContinueWatching"] = "ONDEMAND_CONTINUE_WATCHING";
    BuiltInType["OndemandWatchlist"] = "ONDEMAND_WATCHLIST";
    BuiltInType["PrimeVideoPlaceHolder"] = "PRIME_VIDEO_PLACE_HOLDER";
    BuiltInType["ExpiringStoreContents"] = "EXPIRING_STORE_CONTENTS";
    BuiltInType["RecentlyPurchasedContents"] = "RECENTLY_PURCHASED_CONTENTS";
})(BuiltInType || (BuiltInType = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var BulletpointStyleApiModel;
(function (BulletpointStyleApiModel) {
    BulletpointStyleApiModel["Dark"] = "DARK";
    BulletpointStyleApiModel["Light"] = "LIGHT";
})(BulletpointStyleApiModel || (BulletpointStyleApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * It describes how many whole cards should be visible on the Client side.
 */
var CardNumbersApiModel;
(function (CardNumbersApiModel) {
    CardNumbersApiModel["TwoCards"] = "TWO_CARDS";
    CardNumbersApiModel["ThreeCards"] = "THREE_CARDS";
    CardNumbersApiModel["FourCards"] = "FOUR_CARDS";
    CardNumbersApiModel["FiveCards"] = "FIVE_CARDS";
    CardNumbersApiModel["SixCards"] = "SIX_CARDS";
    CardNumbersApiModel["SevenCards"] = "SEVEN_CARDS";
})(CardNumbersApiModel || (CardNumbersApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * It describes the shape of the card. It is only relevant if the cardStyle is SHAPE_DRIVEN
 */
var CardShapeApiModel;
(function (CardShapeApiModel) {
    CardShapeApiModel["Rectangle"] = "RECTANGLE";
    CardShapeApiModel["Square"] = "SQUARE";
    CardShapeApiModel["Circle"] = "CIRCLE";
})(CardShapeApiModel || (CardShapeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * It describes the look and feel of the card.
 */
var CardStyleApiModel;
(function (CardStyleApiModel) {
    CardStyleApiModel["Horizontal"] = "HORIZONTAL";
    CardStyleApiModel["Portrait"] = "PORTRAIT";
    CardStyleApiModel["Top10Portrait"] = "TOP10_PORTRAIT";
    CardStyleApiModel["Top10Horizontal"] = "TOP10_HORIZONTAL";
    CardStyleApiModel["ShapeDriven"] = "SHAPE_DRIVEN";
})(CardStyleApiModel || (CardStyleApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look\'&feel of the carousel.
 */
var CarouselLayoutApiModel;
(function (CarouselLayoutApiModel) {
    CarouselLayoutApiModel["LandscapeSmall"] = "LandscapeSmall";
    CarouselLayoutApiModel["LandscapeLarge"] = "LandscapeLarge";
    CarouselLayoutApiModel["PortraitSmall"] = "PortraitSmall";
    CarouselLayoutApiModel["PortraitLarge"] = "PortraitLarge";
    CarouselLayoutApiModel["CollectionPortrait"] = "CollectionPortrait";
    CarouselLayoutApiModel["CollectionLandscape"] = "CollectionLandscape";
    CarouselLayoutApiModel["Top10"] = "Top10";
    CarouselLayoutApiModel["MickMack"] = "MickMack";
    CarouselLayoutApiModel["Expendable"] = "Expendable";
})(CarouselLayoutApiModel || (CarouselLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look\'&feel of the carousel.
 */
var CarouselV3LayoutApiModel;
(function (CarouselV3LayoutApiModel) {
    CarouselV3LayoutApiModel["Collection"] = "Collection";
    CarouselV3LayoutApiModel["Portrait"] = "Portrait";
    CarouselV3LayoutApiModel["Landscape"] = "Landscape";
    CarouselV3LayoutApiModel["Top10"] = "Top10";
    CarouselV3LayoutApiModel["Expandable"] = "Expandable";
})(CarouselV3LayoutApiModel || (CarouselV3LayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look\'&feel of the carousel on a collection page.
 */
var CollectionCarouselLayoutApiModel;
(function (CollectionCarouselLayoutApiModel) {
    CollectionCarouselLayoutApiModel["Portrait"] = "Portrait";
    CollectionCarouselLayoutApiModel["Landscape"] = "Landscape";
    CollectionCarouselLayoutApiModel["Top10"] = "Top10";
    CollectionCarouselLayoutApiModel["Expandable"] = "Expandable";
})(CollectionCarouselLayoutApiModel || (CollectionCarouselLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var CollectionPageItemTypeApiModel;
(function (CollectionPageItemTypeApiModel) {
    CollectionPageItemTypeApiModel["CollectionHeroApiModel"] = "CollectionHeroApiModel";
    CollectionPageItemTypeApiModel["CollectionCarouselApiModel"] = "CollectionCarouselApiModel";
    CollectionPageItemTypeApiModel["CollectionTvSeasonApiModel"] = "CollectionTvSeasonApiModel";
    CollectionPageItemTypeApiModel["CollectionMarketingEmailBlockerApiModel"] = "CollectionMarketingEmailBlockerApiModel";
    CollectionPageItemTypeApiModel["CollectionMarketingSpotlightApiModel"] = "CollectionMarketingSpotlightApiModel";
    CollectionPageItemTypeApiModel["CollectionMarketingDeviceModuleApiModel"] = "CollectionMarketingDeviceModuleApiModel";
})(CollectionPageItemTypeApiModel || (CollectionPageItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the cardinality of the config value (list or single value).
 */
var ConfigValueCardinalityApiModel;
(function (ConfigValueCardinalityApiModel) {
    ConfigValueCardinalityApiModel["Single"] = "SINGLE";
    ConfigValueCardinalityApiModel["List"] = "LIST";
})(ConfigValueCardinalityApiModel || (ConfigValueCardinalityApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the type of the config value. Timestamps are always in ISO 8601 format.
 */
var ConfigValueTypeApiModel;
(function (ConfigValueTypeApiModel) {
    ConfigValueTypeApiModel["String"] = "STRING";
    ConfigValueTypeApiModel["Boolean"] = "BOOLEAN";
    ConfigValueTypeApiModel["Number"] = "NUMBER";
    ConfigValueTypeApiModel["Integer"] = "INTEGER";
    ConfigValueTypeApiModel["Date"] = "DATE";
    ConfigValueTypeApiModel["Timestamp"] = "TIMESTAMP";
})(ConfigValueTypeApiModel || (ConfigValueTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var ContentSourceTypeApiModel;
(function (ContentSourceTypeApiModel) {
    ContentSourceTypeApiModel["Uxb"] = "UXB";
    ContentSourceTypeApiModel["Mpx"] = "MPX";
    ContentSourceTypeApiModel["Cmdc"] = "CMDC";
    ContentSourceTypeApiModel["Localdatabase"] = "LOCALDATABASE";
    ContentSourceTypeApiModel["MpxOndemand"] = "MPX_ONDEMAND";
    ContentSourceTypeApiModel["MpxStore"] = "MPX_STORE";
    ContentSourceTypeApiModel["PrimeVideo"] = "PRIME_VIDEO";
})(ContentSourceTypeApiModel || (ContentSourceTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var DescriptionStyleApiModel;
(function (DescriptionStyleApiModel) {
    DescriptionStyleApiModel["Dark"] = "DARK";
    DescriptionStyleApiModel["Light"] = "LIGHT";
})(DescriptionStyleApiModel || (DescriptionStyleApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var DetailPageItemTypeApiModel;
(function (DetailPageItemTypeApiModel) {
    DetailPageItemTypeApiModel["MarketingDetailPageItemApiModel"] = "MarketingDetailPageItemApiModel";
    DetailPageItemTypeApiModel["MarketingDetailDeviceModuleApiModel"] = "MarketingDetailDeviceModuleApiModel";
})(DetailPageItemTypeApiModel || (DetailPageItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the sub status of the current user.
 */
var DthStatusApiModel;
(function (DthStatusApiModel) {
    DthStatusApiModel["Active"] = "active";
    DthStatusApiModel["Inactive"] = "inactive";
    DthStatusApiModel["Suspended"] = "suspended";
})(DthStatusApiModel || (DthStatusApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var GenericCarouselLayoutApiModel;
(function (GenericCarouselLayoutApiModel) {
    GenericCarouselLayoutApiModel["Small"] = "Small";
    GenericCarouselLayoutApiModel["Large"] = "Large";
    GenericCarouselLayoutApiModel["Kids"] = "Kids";
})(GenericCarouselLayoutApiModel || (GenericCarouselLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look&feel of the carousel.
 */
var GenericLayoutApiModel;
(function (GenericLayoutApiModel) {
    GenericLayoutApiModel["TwoCards"] = "TWO_CARDS";
    GenericLayoutApiModel["ThreeCards"] = "THREE_CARDS";
    GenericLayoutApiModel["FourCards"] = "FOUR_CARDS";
    GenericLayoutApiModel["FiveCards"] = "FIVE_CARDS";
    GenericLayoutApiModel["NoThumbnails"] = "NO_THUMBNAILS";
    GenericLayoutApiModel["Top10"] = "TOP10";
    GenericLayoutApiModel["Landscape"] = "LANDSCAPE";
    GenericLayoutApiModel["Portrait"] = "PORTRAIT";
    GenericLayoutApiModel["Collection"] = "COLLECTION";
    GenericLayoutApiModel["Expandable"] = "EXPANDABLE";
    GenericLayoutApiModel["Small"] = "SMALL";
    GenericLayoutApiModel["Medium"] = "MEDIUM";
    GenericLayoutApiModel["Large"] = "LARGE";
    GenericLayoutApiModel["Centered"] = "CENTERED";
    GenericLayoutApiModel["Left"] = "LEFT";
    GenericLayoutApiModel["Right"] = "RIGHT";
    GenericLayoutApiModel["CollectionLandscape"] = "COLLECTION_LANDSCAPE";
    GenericLayoutApiModel["CollectionPortrait"] = "COLLECTION_PORTRAIT";
    GenericLayoutApiModel["LandscapeSmall"] = "LANDSCAPE_SMALL";
    GenericLayoutApiModel["LandscapeLarge"] = "LANDSCAPE_LARGE";
    GenericLayoutApiModel["PortraitSmall"] = "PORTRAIT_SMALL";
    GenericLayoutApiModel["PortraitLarge"] = "PORTRAIT_LARGE";
    GenericLayoutApiModel["MickMack"] = "MICK_MACK";
})(GenericLayoutApiModel || (GenericLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var GenrePageItemTypeApiModel;
(function (GenrePageItemTypeApiModel) {
    GenrePageItemTypeApiModel["GenreHeroApiModel"] = "GenreHeroApiModel";
    GenrePageItemTypeApiModel["GenreCarouselApiModel"] = "GenreCarouselApiModel";
    GenrePageItemTypeApiModel["GenreTvSeasonApiModel"] = "GenreTvSeasonApiModel";
    GenrePageItemTypeApiModel["MarketingEmailBlockerApiModel"] = "MarketingEmailBlockerApiModel";
    GenrePageItemTypeApiModel["MarketingSpotlightApiModel"] = "MarketingSpotlightApiModel";
    GenrePageItemTypeApiModel["MarketingDeviceModuleApiModel"] = "MarketingDeviceModuleApiModel";
})(GenrePageItemTypeApiModel || (GenrePageItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The gradient type of the pageItem
 */
var GradientTypeApiModel;
(function (GradientTypeApiModel) {
    GradientTypeApiModel["Card"] = "CARD";
    GradientTypeApiModel["Text"] = "TEXT";
    GradientTypeApiModel["CardAndText"] = "CARD_AND_TEXT";
    GradientTypeApiModel["NoGradient"] = "NO_GRADIENT";
})(GradientTypeApiModel || (GradientTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingBulletedUspLayoutApiModel;
(function (MarketingBulletedUspLayoutApiModel) {
    MarketingBulletedUspLayoutApiModel["LeftAligned"] = "LEFT_ALIGNED";
    MarketingBulletedUspLayoutApiModel["RightAligned"] = "RIGHT_ALIGNED";
})(MarketingBulletedUspLayoutApiModel || (MarketingBulletedUspLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingDetailLayoutApiModel;
(function (MarketingDetailLayoutApiModel) {
    MarketingDetailLayoutApiModel["LeftAligned"] = "LEFT_ALIGNED";
    MarketingDetailLayoutApiModel["RightAligned"] = "RIGHT_ALIGNED";
    MarketingDetailLayoutApiModel["Centered"] = "CENTERED";
})(MarketingDetailLayoutApiModel || (MarketingDetailLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingEmailLayoutApiModel;
(function (MarketingEmailLayoutApiModel) {
    MarketingEmailLayoutApiModel["LeftAligned"] = "LEFT_ALIGNED";
    MarketingEmailLayoutApiModel["RightAligned"] = "RIGHT_ALIGNED";
    MarketingEmailLayoutApiModel["Centered"] = "CENTERED";
})(MarketingEmailLayoutApiModel || (MarketingEmailLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingGenericVoucherTypeApiModel;
(function (MarketingGenericVoucherTypeApiModel) {
    MarketingGenericVoucherTypeApiModel["VoucherCode"] = "VOUCHER_CODE";
})(MarketingGenericVoucherTypeApiModel || (MarketingGenericVoucherTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingMultipleContentTitleBannerLayoutApiModel;
(function (MarketingMultipleContentTitleBannerLayoutApiModel) {
    MarketingMultipleContentTitleBannerLayoutApiModel["Landscape"] = "Landscape";
    MarketingMultipleContentTitleBannerLayoutApiModel["Portrait"] = "Portrait";
})(MarketingMultipleContentTitleBannerLayoutApiModel || (MarketingMultipleContentTitleBannerLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingPartnerVoucherTypeApiModel;
(function (MarketingPartnerVoucherTypeApiModel) {
    MarketingPartnerVoucherTypeApiModel["VoucherCode"] = "VOUCHER_CODE";
    MarketingPartnerVoucherTypeApiModel["CardNumber"] = "CARD_NUMBER";
})(MarketingPartnerVoucherTypeApiModel || (MarketingPartnerVoucherTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingRedeemCtaLayoutApiModel;
(function (MarketingRedeemCtaLayoutApiModel) {
    MarketingRedeemCtaLayoutApiModel["LeftAligned"] = "LEFT_ALIGNED";
    MarketingRedeemCtaLayoutApiModel["RightAligned"] = "RIGHT_ALIGNED";
})(MarketingRedeemCtaLayoutApiModel || (MarketingRedeemCtaLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingRedeemPageItemTypeApiModel;
(function (MarketingRedeemPageItemTypeApiModel) {
    MarketingRedeemPageItemTypeApiModel["MarketingGenericVoucherApiModel"] = "MarketingGenericVoucherApiModel";
    MarketingRedeemPageItemTypeApiModel["MarketingPartnerVoucherApiModel"] = "MarketingPartnerVoucherApiModel";
    MarketingRedeemPageItemTypeApiModel["MarketingBulletedUspApiModel"] = "MarketingBulletedUspApiModel";
    MarketingRedeemPageItemTypeApiModel["MarketingRedeemCtaApiModel"] = "MarketingRedeemCtaApiModel";
    MarketingRedeemPageItemTypeApiModel["MarketingRedeemFaqApiModel"] = "MarketingRedeemFaqApiModel";
})(MarketingRedeemPageItemTypeApiModel || (MarketingRedeemPageItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingTrayButtonActionApiModel;
(function (MarketingTrayButtonActionApiModel) {
    MarketingTrayButtonActionApiModel["SignIn"] = "SignIn";
    MarketingTrayButtonActionApiModel["SignUp"] = "SignUp";
    MarketingTrayButtonActionApiModel["CompleteSubscription"] = "CompleteSubscription";
    MarketingTrayButtonActionApiModel["CustomUrl"] = "CustomUrl";
    MarketingTrayButtonActionApiModel["NewPassword"] = "NewPassword";
    MarketingTrayButtonActionApiModel["CxbPage"] = "CxbPage";
    MarketingTrayButtonActionApiModel["Content"] = "Content";
    MarketingTrayButtonActionApiModel["Subscribe"] = "Subscribe";
})(MarketingTrayButtonActionApiModel || (MarketingTrayButtonActionApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingTrayLayoutApiModel;
(function (MarketingTrayLayoutApiModel) {
    MarketingTrayLayoutApiModel["LeftAligned"] = "LeftAligned";
    MarketingTrayLayoutApiModel["RightAligned"] = "RightAligned";
})(MarketingTrayLayoutApiModel || (MarketingTrayLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MarketingVideoSourceApiModel;
(function (MarketingVideoSourceApiModel) {
    MarketingVideoSourceApiModel["Youtube"] = "YOUTUBE";
})(MarketingVideoSourceApiModel || (MarketingVideoSourceApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var MenuItemTypeApiModel;
(function (MenuItemTypeApiModel) {
    MenuItemTypeApiModel["Normal"] = "normal";
    MenuItemTypeApiModel["Live"] = "live";
    MenuItemTypeApiModel["Apps"] = "apps";
    MenuItemTypeApiModel["Home"] = "home";
    MenuItemTypeApiModel["Ondemand"] = "ondemand";
    MenuItemTypeApiModel["Mytv"] = "mytv";
    MenuItemTypeApiModel["Tvguide"] = "tvguide";
    MenuItemTypeApiModel["Search"] = "search";
    MenuItemTypeApiModel["Tvod"] = "tvod";
})(MenuItemTypeApiModel || (MenuItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the mobile layout size.
 */
var MobileLayoutModel;
(function (MobileLayoutModel) {
    MobileLayoutModel["Small"] = "SMALL";
    MobileLayoutModel["Large"] = "LARGE";
})(MobileLayoutModel || (MobileLayoutModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var PageItemTypeApiModel;
(function (PageItemTypeApiModel) {
    PageItemTypeApiModel["SpotlightApiModel"] = "SpotlightApiModel";
    PageItemTypeApiModel["SpotlightV3ApiModel"] = "SpotlightV3ApiModel";
    PageItemTypeApiModel["SpotlightV4ApiModel"] = "SpotlightV4ApiModel";
    PageItemTypeApiModel["CurrentlyOnTvTrayApiModel"] = "CurrentlyOnTvTrayApiModel";
    PageItemTypeApiModel["UpcomingLiveTvContentTrayApiModel"] = "UpcomingLiveTvContentTrayApiModel";
    PageItemTypeApiModel["ChannelSpecificUpcomingTrayApiModel"] = "ChannelSpecificUpcomingTrayApiModel";
    PageItemTypeApiModel["TvChannelLogoTrayApiModel"] = "TvChannelLogoTrayApiModel";
    PageItemTypeApiModel["BannersWithCtaTrayApiModel"] = "BannersWithCtaTrayApiModel";
    PageItemTypeApiModel["BannersTrayApiModel"] = "BannersTrayApiModel";
    PageItemTypeApiModel["VodContentTrayApiModel"] = "VodContentTrayApiModel";
    PageItemTypeApiModel["BuiltInTrayApiModel"] = "BuiltInTrayApiModel";
    PageItemTypeApiModel["BuiltInTrayV3ApiModel"] = "BuiltInTrayV3ApiModel";
    PageItemTypeApiModel["BuiltInTrayV4ApiModel"] = "BuiltInTrayV4ApiModel";
    PageItemTypeApiModel["BuiltInApiModel"] = "BuiltInApiModel";
    PageItemTypeApiModel["RecommendedAppsTrayApiModel"] = "RecommendedAppsTrayApiModel";
    PageItemTypeApiModel["CollectionsTrayApiModel"] = "CollectionsTrayApiModel";
    PageItemTypeApiModel["FullscreenTrayApiModel"] = "FullscreenTrayApiModel";
    PageItemTypeApiModel["OtherAppsTrayApiModel"] = "OtherAppsTrayApiModel";
    PageItemTypeApiModel["TopTenOnLiveTvTrayApiModel"] = "TopTenOnLiveTvTrayApiModel";
    PageItemTypeApiModel["TopTenVodContentTrayApiModel"] = "TopTenVodContentTrayApiModel";
    PageItemTypeApiModel["RecentlyWatchedTvTrayApiModel"] = "RecentlyWatchedTvTrayApiModel";
    PageItemTypeApiModel["InstalledAppsTrayApiModel"] = "InstalledAppsTrayApiModel";
    PageItemTypeApiModel["MarketingBannerTrayApiModel"] = "MarketingBannerTrayApiModel";
    PageItemTypeApiModel["RecommendationTrayApiModel"] = "RecommendationTrayApiModel";
    PageItemTypeApiModel["RecommendedChannelsTrayApiModel"] = "RecommendedChannelsTrayApiModel";
    PageItemTypeApiModel["SearchTagsApiModel"] = "SearchTagsApiModel";
    PageItemTypeApiModel["SearchTagsV3ApiModel"] = "SearchTagsV3ApiModel";
    PageItemTypeApiModel["TvSeasonTrayApiModel"] = "TvSeasonTrayApiModel";
    PageItemTypeApiModel["MarketingEmailBlockerTrayApiModel"] = "MarketingEmailBlockerTrayApiModel";
    PageItemTypeApiModel["MarketingCtaApiModel"] = "MarketingCtaApiModel";
    PageItemTypeApiModel["MarketingUspApiModel"] = "MarketingUspApiModel";
    PageItemTypeApiModel["StudioTrayApiModel"] = "StudioTrayApiModel";
    PageItemTypeApiModel["GenreTrayApiModel"] = "GenreTrayApiModel";
    PageItemTypeApiModel["HeroApiModel"] = "HeroApiModel";
    PageItemTypeApiModel["MarketingDetailApiModel"] = "MarketingDetailApiModel";
    PageItemTypeApiModel["CarouselApiModel"] = "CarouselApiModel";
    PageItemTypeApiModel["MarketingStudioApiModel"] = "MarketingStudioApiModel";
    PageItemTypeApiModel["MarketingKidsApiModel"] = "MarketingKidsApiModel";
    PageItemTypeApiModel["MarketingHeroApiModel"] = "MarketingHeroApiModel";
    PageItemTypeApiModel["MarketingFaqApiModel"] = "MarketingFaqApiModel";
    PageItemTypeApiModel["TvSeasonCarouselApiModel"] = "TvSeasonCarouselApiModel";
    PageItemTypeApiModel["TvSeasonCarouselV3ApiModel"] = "TvSeasonCarouselV3ApiModel";
    PageItemTypeApiModel["RecommendationTrayV3ApiModel"] = "RecommendationTrayV3ApiModel";
    PageItemTypeApiModel["ContentMarketingEmailBlockerApiModel"] = "ContentMarketingEmailBlockerApiModel";
    PageItemTypeApiModel["ContentMarketingSpotlightApiModel"] = "ContentMarketingSpotlightApiModel";
    PageItemTypeApiModel["ContentMarketingDeviceModuleApiModel"] = "ContentMarketingDeviceModuleApiModel";
    PageItemTypeApiModel["CarouselV3ApiModel"] = "CarouselV3ApiModel";
    PageItemTypeApiModel["GenericCarouselApiModel"] = "GenericCarouselApiModel";
    PageItemTypeApiModel["GenreTrayV4ApiModel"] = "GenreTrayV4ApiModel";
    PageItemTypeApiModel["StudioTrayV4ApiModel"] = "StudioTrayV4ApiModel";
    PageItemTypeApiModel["MarketingMultipleContentTitleBannerApiModel"] = "MarketingMultipleContentTitleBannerApiModel";
    PageItemTypeApiModel["MarketingEmailCollectorApiModel"] = "MarketingEmailCollectorApiModel";
    PageItemTypeApiModel["MarketingCtaBulletedListApiModel"] = "MarketingCtaBulletedListApiModel";
    PageItemTypeApiModel["MarketingTrendingApiModel"] = "MarketingTrendingApiModel";
    PageItemTypeApiModel["CatchUpTrayApiModel"] = "CatchUpTrayApiModel";
    PageItemTypeApiModel["ChannelSpecificCatchUpTrayApiModel"] = "ChannelSpecificCatchUpTrayApiModel";
    PageItemTypeApiModel["LandscapeTrayApiModel"] = "LandscapeTrayApiModel";
    PageItemTypeApiModel["CategoryTrayApiModel"] = "CategoryTrayApiModel";
    PageItemTypeApiModel["CategoryTrayV4ApiModel"] = "CategoryTrayV4ApiModel";
    PageItemTypeApiModel["SeasonTrayApiModel"] = "SeasonTrayApiModel";
    PageItemTypeApiModel["MarketingVideoApiModel"] = "MarketingVideoApiModel";
    PageItemTypeApiModel["MarketingBarApiModel"] = "MarketingBarApiModel";
    PageItemTypeApiModel["ComingSoonTrayApiModel"] = "ComingSoonTrayApiModel";
    PageItemTypeApiModel["OndemandBannerTrayApiModel"] = "OndemandBannerTrayApiModel";
    PageItemTypeApiModel["MixedSearchTagsApiModel"] = "MixedSearchTagsApiModel";
})(PageItemTypeApiModel || (PageItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of the page item
 */
var PageItemTypeApiModel2;
(function (PageItemTypeApiModel2) {
    PageItemTypeApiModel2["LandscapeTrayApiModel"] = "LandscapeTrayApiModel";
    PageItemTypeApiModel2["CategoryTrayApiModel"] = "CategoryTrayApiModel";
    PageItemTypeApiModel2["CategoryTrayV4ApiModel"] = "CategoryTrayV4ApiModel";
    PageItemTypeApiModel2["SearchTagsV3ApiModel"] = "SearchTagsV3ApiModel";
    PageItemTypeApiModel2["CollectionsTrayApiModel"] = "CollectionsTrayApiModel";
    PageItemTypeApiModel2["FullscreenTrayApiModel"] = "FullscreenTrayApiModel";
    PageItemTypeApiModel2["BannersTrayApiModel"] = "BannersTrayApiModel";
    PageItemTypeApiModel2["MixedSearchTagsApiModel"] = "MixedSearchTagsApiModel";
})(PageItemTypeApiModel2 || (PageItemTypeApiModel2 = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the name of the platform of the current user.
 */
var PlatformApiModel;
(function (PlatformApiModel) {
    PlatformApiModel["Web"] = "WEB";
    PlatformApiModel["Mobile"] = "MOBILE";
    PlatformApiModel["Tablet"] = "TABLET";
    PlatformApiModel["Bigscreen"] = "BIGSCREEN";
    PlatformApiModel["Settopbox"] = "SETTOPBOX";
})(PlatformApiModel || (PlatformApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The platform of the client application
 */
var PlatformV2ApiModel;
(function (PlatformV2ApiModel) {
    PlatformV2ApiModel["Web"] = "WEB";
    PlatformV2ApiModel["MobileAndroid"] = "MOBILE_ANDROID";
    PlatformV2ApiModel["MobileIos"] = "MOBILE_IOS";
    PlatformV2ApiModel["TabletAndroid"] = "TABLET_ANDROID";
    PlatformV2ApiModel["TabletIos"] = "TABLET_IOS";
    PlatformV2ApiModel["AndroidTv"] = "ANDROID_TV";
    PlatformV2ApiModel["AppleTv"] = "APPLE_TV";
    PlatformV2ApiModel["Lg"] = "LG";
    PlatformV2ApiModel["Hisense"] = "HISENSE";
    PlatformV2ApiModel["Samsung"] = "SAMSUNG";
})(PlatformV2ApiModel || (PlatformV2ApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The profile type of the client application
 */
var ProfileTypeApiModel;
(function (ProfileTypeApiModel) {
    ProfileTypeApiModel["Kids"] = "KIDS";
    ProfileTypeApiModel["Adult"] = "ADULT";
    ProfileTypeApiModel["Default"] = "DEFAULT";
})(ProfileTypeApiModel || (ProfileTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var ProgramTypeApiModel;
(function (ProgramTypeApiModel) {
    ProgramTypeApiModel["Movie"] = "Movie";
    ProgramTypeApiModel["Series"] = "Series";
    ProgramTypeApiModel["Episode"] = "Episode";
})(ProgramTypeApiModel || (ProgramTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look\'&feel of the recommendation for both cxb and stb.
 */
var RecommendationLayoutApiModel;
(function (RecommendationLayoutApiModel) {
    RecommendationLayoutApiModel["Landscape"] = "Landscape";
    RecommendationLayoutApiModel["LandscapeSmall"] = "LandscapeSmall";
    RecommendationLayoutApiModel["LandscapeLarge"] = "LandscapeLarge";
    RecommendationLayoutApiModel["Portrait"] = "Portrait";
    RecommendationLayoutApiModel["PortraitSmall"] = "PortraitSmall";
    RecommendationLayoutApiModel["PortraitLarge"] = "PortraitLarge";
    RecommendationLayoutApiModel["Collection"] = "Collection";
    RecommendationLayoutApiModel["CollectionPortrait"] = "CollectionPortrait";
    RecommendationLayoutApiModel["CollectionLandscape"] = "CollectionLandscape";
    RecommendationLayoutApiModel["Top10"] = "Top10";
    RecommendationLayoutApiModel["MickMack"] = "MickMack";
    RecommendationLayoutApiModel["Expendable"] = "Expendable";
})(RecommendationLayoutApiModel || (RecommendationLayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look\'&feel of the recommendation tray.
 */
var RecommendationTrayV3LayoutApiModel;
(function (RecommendationTrayV3LayoutApiModel) {
    RecommendationTrayV3LayoutApiModel["Collection"] = "Collection";
    RecommendationTrayV3LayoutApiModel["Portrait"] = "Portrait";
    RecommendationTrayV3LayoutApiModel["Landscape"] = "Landscape";
    RecommendationTrayV3LayoutApiModel["Top10"] = "Top10";
    RecommendationTrayV3LayoutApiModel["Expandable"] = "Expandable";
})(RecommendationTrayV3LayoutApiModel || (RecommendationTrayV3LayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the title display mode of the Samsung Smart Hub Preview title/subtitle
 */
var SamsungSmartHubPreviewTitleDisplayModeApiModel;
(function (SamsungSmartHubPreviewTitleDisplayModeApiModel) {
    SamsungSmartHubPreviewTitleDisplayModeApiModel["AlwaysOn"] = "AlwaysOn";
    SamsungSmartHubPreviewTitleDisplayModeApiModel["HighlightedOnly"] = "HighlightedOnly";
    SamsungSmartHubPreviewTitleDisplayModeApiModel["AccessibilityOnly"] = "AccessibilityOnly";
})(SamsungSmartHubPreviewTitleDisplayModeApiModel || (SamsungSmartHubPreviewTitleDisplayModeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the content type of the result
 */
var SimilarTitleTypeApiModel;
(function (SimilarTitleTypeApiModel) {
    SimilarTitleTypeApiModel["Vod"] = "VOD";
    SimilarTitleTypeApiModel["Live"] = "LIVE";
})(SimilarTitleTypeApiModel || (SimilarTitleTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the default sorting order in a list of elements.
 */
var SortOrderApiModel;
(function (SortOrderApiModel) {
    SortOrderApiModel["Ascending"] = "Ascending";
    SortOrderApiModel["Descending"] = "Descending";
})(SortOrderApiModel || (SortOrderApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Discriminator to distinguish between different spotlight item types
 */
var SpotlightItemTypeApiModel;
(function (SpotlightItemTypeApiModel) {
    SpotlightItemTypeApiModel["VodSpotlightItemApiModel"] = "VodSpotlightItemApiModel";
    SpotlightItemTypeApiModel["LinearSpotlightItemApiModel"] = "LinearSpotlightItemApiModel";
    SpotlightItemTypeApiModel["CurrentlyOnTvSpotlightItemApiModel"] = "CurrentlyOnTvSpotlightItemApiModel";
    SpotlightItemTypeApiModel["OndemandSpotlightItemApiModel"] = "OndemandSpotlightItemApiModel";
    SpotlightItemTypeApiModel["StoreSpotlightItemApiModel"] = "StoreSpotlightItemApiModel";
})(SpotlightItemTypeApiModel || (SpotlightItemTypeApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var TextStyleApiModel;
(function (TextStyleApiModel) {
    TextStyleApiModel["Dark"] = "DARK";
    TextStyleApiModel["Light"] = "LIGHT";
})(TextStyleApiModel || (TextStyleApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var TitleStyleApiModel;
(function (TitleStyleApiModel) {
    TitleStyleApiModel["Dark"] = "DARK";
    TitleStyleApiModel["Light"] = "LIGHT";
})(TitleStyleApiModel || (TitleStyleApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the look\'&feel of the tv season tray.
 */
var TvSeasonTrayV3LayoutApiModel;
(function (TvSeasonTrayV3LayoutApiModel) {
    TvSeasonTrayV3LayoutApiModel["Collection"] = "Collection";
    TvSeasonTrayV3LayoutApiModel["Portrait"] = "Portrait";
    TvSeasonTrayV3LayoutApiModel["Landscape"] = "Landscape";
    TvSeasonTrayV3LayoutApiModel["Top10"] = "Top10";
    TvSeasonTrayV3LayoutApiModel["Expandable"] = "Expandable";
})(TvSeasonTrayV3LayoutApiModel || (TvSeasonTrayV3LayoutApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Describes the status of the current user.
 */
var UserSegmentApiModel;
(function (UserSegmentApiModel) {
    UserSegmentApiModel["Anonymous"] = "anonymous";
    UserSegmentApiModel["Normal"] = "normal";
    UserSegmentApiModel["PendingChurn"] = "pending-churn";
    UserSegmentApiModel["Dunning"] = "dunning";
    UserSegmentApiModel["Churned"] = "churned";
    UserSegmentApiModel["Prospect"] = "prospect";
})(UserSegmentApiModel || (UserSegmentApiModel = {}));
;

/**
 * UXB API Collection
 * For the sake of separating the APIs, every endpoint should be defined in their own .yaml file. We separate them one by one for each microservice and for every endpoint that needs to be generated should be also referenced here. For the documentation of the OpenApi generator, see -> https://www.npmjs.com/package/@team-supercharge/oasg#simple
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: richard.bogehold@wecanconsulting.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

class ApiModule {
    constructor(parentModule, http) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
    static forRoot(configurationFactory) {
        return {
            ngModule: ApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }]
        };
    }
}
ApiModule.ɵfac = function ApiModule_Factory(t) { return new (t || ApiModule)(ɵngcc0.ɵɵinject(ApiModule, 12), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient, 8)); };
ApiModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ApiModule });
ApiModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
ApiModule.ctorParameters = () => [
    { type: ApiModule, decorators: [{ type: Optional }, { type: SkipSelf }] },
    { type: HttpClient, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApiModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
                providers: []
            }]
    }], function () { return [{ type: ApiModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc1.HttpClient, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { APIS, ApiModule, AvailabilityTagApiModel, BASE_PATH, BannersWithCtaTraylLayoutApiModel, BuiltInCxbType, BuiltInType, BulletpointStyleApiModel, COLLECTION_FORMATS, CardNumbersApiModel, CardShapeApiModel, CardStyleApiModel, CarouselLayoutApiModel, CarouselV3LayoutApiModel, CollectionCarouselLayoutApiModel, CollectionPageItemTypeApiModel, ConfigValueCardinalityApiModel, ConfigValueTypeApiModel, Configuration, ContentSourceTypeApiModel, DescriptionStyleApiModel, DetailPageItemTypeApiModel, DthStatusApiModel, GenericCarouselLayoutApiModel, GenericLayoutApiModel, GenrePageItemTypeApiModel, GoogleAuthenticationDataService, GradientTypeApiModel, LinearConfigDataService, LinearFeedDataService, LinearMenuDataService, LinearPageDataService, LinearRecommendationSearchDataService, LinearSearchDataService, LinearTenantConfigDataService, MarketingBulletedUspLayoutApiModel, MarketingDetailLayoutApiModel, MarketingEmailLayoutApiModel, MarketingGenericVoucherTypeApiModel, MarketingMultipleContentTitleBannerLayoutApiModel, MarketingPartnerVoucherTypeApiModel, MarketingRedeemCtaLayoutApiModel, MarketingRedeemPageItemTypeApiModel, MarketingTrayButtonActionApiModel, MarketingTrayLayoutApiModel, MarketingVideoSourceApiModel, MenuItemTypeApiModel, MobileLayoutModel, OndemandRecommendationDataService, PageItemTypeApiModel, PageItemTypeApiModel2, PlatformApiModel, PlatformV2ApiModel, ProfileTypeApiModel, ProgramTypeApiModel, RecommendationLayoutApiModel, RecommendationTrayV3LayoutApiModel, SamsungSmartHubPreviewTitleDisplayModeApiModel, SimilarTitleTypeApiModel, SortOrderApiModel, SpotlightItemTypeApiModel, StbRecommendationLearnDataService, StbRecommendationSimilarTitlesDataService, StbRecommendationTrayDataService, StreamingAppleDataService, StreamingClientConfigDataService, StreamingCollectionPageDataService, StreamingDetailPageDataService, StreamingGatewayRedeemAssetsDataService, StreamingGenrePageDataService, StreamingMenuDataService, StreamingPageDataService, StreamingPaywallDataService, StreamingRecommendationLearnDataService, StreamingRecommendationRecommendedForYouDataService, StreamingRecommendationSearchDataService, StreamingRecommendationTrayDataService, StreamingRecommendationTrendingDataService, StreamingRedeemPageDataService, StreamingSamsungSmartHubDataService, StreamingSearchDataService, StreamingSimilarTitlesDataService, StreamingVersionDataService, TextStyleApiModel, TitleStyleApiModel, TvSeasonTrayV3LayoutApiModel, UserSegmentApiModel };

